var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "MountingPortal",
    {
      attrs: {
        mountTo: "body",
        append: "",
      },
    },
    [
      _c(
        "focus-trap",
        {
          attrs: {
            "initial-focus": function initialFocus() {
              return _vm.$refs.buttonB
            },
          },
          model: {
            value: _vm.trap,
            callback: function callback($$v) {
              _vm.trap = $$v
            },
            expression: "trap",
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "studip-dialog",
              on: {
                keydown: function keydown($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  ) {
                    return null
                  }
                  return _vm.closeDialog.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "transition",
                {
                  attrs: {
                    name: "dialog-fade",
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "studip-dialog-backdrop",
                    },
                    [
                      _c(
                        "vue-resizeable",
                        {
                          ref: "resizableComponent",
                          staticClass: "resizable",
                          staticStyle: {
                            position: "absolute",
                          },
                          attrs: {
                            dragSelector: _vm.dragSelector,
                            active: _vm.handlers,
                            "fit-parent": _vm.fit,
                            left: _vm.left,
                            top: _vm.top,
                            width: _vm.currentWidth,
                            height: _vm.currentHeight,
                            "min-width": _vm._f("checkEmpty")(_vm.minW),
                            "min-height": _vm._f("checkEmpty")(_vm.minH),
                          },
                          on: {
                            mount: _vm.initSize,
                            "resize:move": _vm.resizeHandler,
                            "resize:start": _vm.resizeHandler,
                            "resize:end": _vm.resizeHandler,
                            "drag:move": _vm.resizeHandler,
                            "drag:start": _vm.resizeHandler,
                            "drag:end": _vm.resizeHandler,
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              ref: "dialog",
                              staticClass: "studip-dialog-body",
                              class: {
                                "studip-dialog-warning": _vm.question,
                                "studip-dialog-alert": _vm.alert,
                              },
                              style: {
                                width: _vm.dialogWidth,
                                height: _vm.dialogHeight,
                                top: _vm.top,
                                left: _vm.left,
                              },
                              attrs: {
                                role: "dialog",
                                "aria-modal": "true",
                                "aria-labelledby": _vm.dialogTitleId,
                                "aria-describedby": _vm.dialogDescId,
                              },
                            },
                            [
                              _c(
                                "header",
                                {
                                  staticClass: "studip-dialog-header",
                                },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass: "studip-dialog-title",
                                      attrs: {
                                        id: _vm.dialogTitleId,
                                        title: _vm.dialogTitle,
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(_vm.dialogTitle) +
                                          "\n                                "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm._t("dialogHeader"),
                                  _vm._v(" "),
                                  _c("button", {
                                    staticClass: "studip-dialog-close-button",
                                    attrs: {
                                      "aria-label": _vm.$gettext(
                                        "Diesen Dialog schließen"
                                      ),
                                      title: _vm.$gettext("Schließen"),
                                    },
                                    on: {
                                      click: _vm.closeDialog,
                                    },
                                  }),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "section",
                                {
                                  staticClass: "studip-dialog-content",
                                  style: {
                                    height: _vm.contentHeight,
                                  },
                                  attrs: {
                                    id: _vm.dialogDescId,
                                  },
                                },
                                [
                                  _vm._t("dialogContent"),
                                  _vm._v(" "),
                                  _vm.message
                                    ? _c("div", [_vm._v(_vm._s(_vm.message))])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.question
                                    ? _c("div", [_vm._v(_vm._s(_vm.question))])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.alert
                                    ? _c("div", [_vm._v(_vm._s(_vm.alert))])
                                    : _vm._e(),
                                ],
                                2
                              ),
                              _vm._v(" "),
                              _c(
                                "footer",
                                {
                                  ref: "footer",
                                  staticClass: "studip-dialog-footer",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "studip-dialog-footer-buttonset-left",
                                    },
                                    [_vm._t("dialogButtonsBefore")],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "studip-dialog-footer-buttonset-center",
                                    },
                                    [
                                      _vm.buttonA
                                        ? _c(
                                            "button",
                                            {
                                              staticClass: "button",
                                              class: [_vm.buttonA.class],
                                              attrs: {
                                                title: _vm.buttonA.text,
                                                disabled: _vm.buttonA.disabled,
                                                type: "button",
                                              },
                                              on: {
                                                click: _vm.confirmDialog,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.buttonA.text) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm._t("dialogButtons"),
                                      _vm._v(" "),
                                      _vm.buttonB
                                        ? _c(
                                            "button",
                                            {
                                              ref: "buttonB",
                                              staticClass: "button",
                                              class: [_vm.buttonB.class],
                                              attrs: {
                                                title: _vm.buttonB.text,
                                                type: "button",
                                              },
                                              on: {
                                                click: _vm.closeDialog,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(_vm.buttonB.text) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "studip-dialog-footer-buttonset-right",
                                    },
                                    [_vm._t("dialogButtonsAfter")],
                                    2
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }